// import './UserWithdrawHistry.css';
import React, { useState, useEffect } from "react";
import "./TradePair.css";
import {
  Avatar,
  Box,
  Button,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid2,
  IconButton,
  MenuItem,
  Modal,
  Select,
  Tab,
  TextField,
  Typography,
} from "@mui/material";
import Header from "../Header/Header";
import Pagination from "@mui/material/Pagination";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import consts from "../../constant";
import Axios from "axios";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { useNavigate } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import { ToastContainer, toast } from "react-toastify";
import usercalls from "../../Axios";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import ModeTwoToneIcon from "@mui/icons-material/ModeTwoTone";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import Switch from "@mui/material/Switch";
import DialogActions from "@mui/material/DialogActions";
import { styled, useTheme } from "@mui/material/styles";

const drawerWidth = 260;

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(2),
    justifyContent: "center",
  },
}));

const TradePair = () => {
  const [result, setResult] = useState([]);
  const Navigate = useNavigate();
  const tabelHeader = [
    "S.no",
    "Trade pair",
    "Base Asset",
    "Market Asset",
    ,
    "Type",
    // "min_buy_price", "min_buy_quantity", "min_sell_price", "min_sell_quantity",
    // "max_buy_price", "max_buy_quantity", "max_sell_price", "max_sell_quantity",
    // "price", "trade_cap_value", "point_value_base", "point_value_market", "instant_buy_sell_commision",
    // "convert_price", "buy_trade_commission",
    "status",
    "Action",
  ];

  const theme = useTheme();
  const lg = useMediaQuery(theme.breakpoints.up("lg"));
  const [pairList, setpairList] = useState();
  const [addpage, setaddpage] = useState(false);
  const [on, seton] = useState(false);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [loader, setloader] = useState(false);
  const path = usercalls();
  const [data, setData] = useState([]);
  const [isLoad, setIsLoad] = useState(false);
  const [totalPage, setTotalPage] = useState(0);

  const token = localStorage.getItem("adminToken");

  const getPairs = async () => {
    const url = `${consts.BackendUrl}/admin/getPairList`;
    //   const response = await path.getCallWithToken({ url });

    //   const result = await response.json();
    //   console.log(result, "result");
    //   if (result?.success) {
    //     setData(result?.result);
    //     setloader(false);
    //     setTotalPage(Math.ceil(result?.result.length / limit));
    //   }
    // };
    // const url = "http://localhost:3500/tajirex/admin/getPairList";
    Axios.get(url)
      .then((response) => {
        setData(response?.data);
        setloader(false);
        setTotalPage(Math.ceil(response?.data.length / limit));
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  useEffect(() => {
    if (localStorage.getItem("adminToken")) {
      getPairs();
    } else {
      Navigate(`/${consts.route + "/login"}`);
    }
  }, []);

  const handleClickOpen = (row) => {
    setPairDetils(row);
    setOpenmodel(true);
  };

  const [openModel, setOpenmodel] = useState(false);
  const [pairDetils, setPairDetils] = useState({});

  const handleClose = () => {
    setOpenmodel(false);
  };

  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      try {
        const formData = new FormData();
        formData.append("image", file);

        const response = await Axios.post(
          `${consts.BackendUrl}/admin/imageUploadAdmin`,
          formData,
          {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Headers": "Content-Type, Authorization",
              "Access-Control-Allow-Credentials": "true",
              "Access-Control-Allow-Methods":
                "GET,PUT,POST,DELETE,PATCH,OPTIONS",
              Authorization: token,
            },
          }
        );
        if (response?.data?.success) {
          const uploadedImageUrl = response?.data?.result;

          setPairDetils((prevDetails) => ({
            ...prevDetails,
            icon: uploadedImageUrl,
          }));
        } else {
          console.error("Failed to upload image. No URL returned.");
        }
      } catch (error) {
        console.error("Error uploading image:", error);
      }
    }
  };

  const handleSwitchChange = (isEnabled) => {
    setPairDetils((prevDetails) => ({
      ...prevDetails,
      status: isEnabled,
    }));
  };

  const handleSave = async () => {
    try {
      setIsLoad(true);
      const response = await Axios.post(
        `${consts.BackendUrl}/admin/edittradepair`,
        { updateData: pairDetils, id: pairDetils?._id },
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Headers": "Content-Type, Authorization",
            "Access-Control-Allow-Credentials": "true",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
            Authorization: token,
          },
        }
      );
      if (response?.data?.success) {
        setTimeout(() => {
          toast.success(response?.data?.message);
        }, 1000);
        setOpenmodel(false);
        getPairs();
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.error("Error updating Pair", error);
    } finally {
      setIsLoad(false);
    }
  };

  return (
    <div className="Asset">
      <ToastContainer />
      <Box sx={{ display: lg ? "flex" : "block" }}>
        <Header />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 5,
            width: { lg: `calc(100% - ${drawerWidth}px)` },
            marginTop: "50px",
          }}
        >
          <Grid2 container spacing={2}>
            <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
              <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <Button
                  variant="contained"
                  sx={{
                    marginLeft: "auto",
                    display: "block",
                    marginTop: "20px",
                  }}
                  onClick={() => {
                    Navigate(`/${consts.route}/createAdminStake`);
                  }}
                >
                  Create
                </Button>
              </Grid2>

              <div className="custom_table">
                <TableContainer>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        {tabelHeader.map((val, index) => {
                          return <TableCell align="center"> {val}</TableCell>;
                        })}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {[...data]
                        .slice((page - 1) * limit, page * limit)
                        ?.map((value, index) => (
                          <TableRow
                            key={index}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <TableCell align="center">
                              {limit * (page - 1) + index + 1}
                            </TableCell>
                            <TableCell align="center">
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: 2,
                                }}
                              >
                                {!value?.icon ? (
                                  <Avatar sx={{ width: 25, height: 25 }}>
                                    {value?.pair_symbol?.charAt(0)}
                                  </Avatar>
                                ) : (
                                  <img
                                    style={{ width: "30px", height: "30px" }}
                                    src={value?.icon}
                                    alt={value?.pair_symbol}
                                  />
                                )}
                                <span>{value?.pair_symbol}</span>
                              </Box>
                            </TableCell>
                            <TableCell align="center">
                              {value?.base_asset_name}
                            </TableCell>
                            <TableCell align="center">
                              {value?.market_asset_name}
                            </TableCell>
                            <TableCell align="center">{value?.type}</TableCell>
                            <TableCell align="center">
                              {value?.status ? (
                                <CheckCircleOutlineOutlinedIcon
                                  sx={{ fill: "green" }}
                                />
                              ) : (
                                <BlockOutlinedIcon sx={{ fill: "red" }} />
                              )}
                            </TableCell>
                            <TableCell align="center">
                              <Button
                                sx={{
                                  marginLeft: "10px",
                                  backgroundColor: "#1976d2",
                                  color: "#fff",
                                  "&:hover": { backgroundColor: "#1565c0" },
                                  padding: "8px 16px",
                                  borderRadius: "8px",
                                  fontWeight: "bold",
                                }}
                                variant="contained"
                                onClick={() => handleClickOpen(value)}
                              >
                                Edit
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Pagination
                  className="pagnation"
                  count={totalPage}
                  page={page}
                  onChange={(event, value) => {
                    setPage(value);
                  }}
                  // color='primary'
                  shape="rounded"
                />
              </div>
            </Grid2>
          </Grid2>
        </Box>
      </Box>

      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={openModel}
        className="edit-dialogbox"
        sx={{
          "& .MuiDialog-paper": {
            backgroundColor: "#10212c",
            color: "#fff",
            width: "900px",
            margin: 0,
          },
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          EDIT
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          {/* Image Upload Section */}
          <div
            className="image-upload-section"
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <Avatar
              alt="Current Image"
              src={pairDetils?.icon || ""}
              sx={{ width: 80, height: 80, marginRight: "20px" }}
            />
            <Button variant="contained" component="label">
              Upload Image
              <input
                type="file"
                hidden
                accept="image/*"
                onChange={(e) => handleImageUpload(e)}
              />
            </Button>
          </div>

          {/* Switch Button */}
          <div className="switch-section" style={{ marginBottom: "20px" }}>
            <FormControlLabel
              control={
                <Switch
                  checked={pairDetils?.status || false}
                  onChange={(e) => handleSwitchChange(e.target.checked)}
                  color="primary"
                />
              }
              label="Enable/Disable Pair"
            />
          </div>

          {/* Form Fields */}
          <Grid2
            container
            spacing={2}
            style={{ height: "100%" }}
            sx={{
              "& .MuiTextField-root": {
                width: "100%",
              },
              "& .MuiInputBase-input.MuiOutlinedInput-input": {
                color: "white",
              },
              "& .MuiOutlinedInput-root": {
                "& fieldset": {},
              },
            }}
            alignItems={"center"}
          >
            {/* Left Column */}
            <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}>
              <div className="view-inp p-10">
                <div className="">Price</div>
                <div className="mt-10">
                  <TextField
                    value={pairDetils?.price}
                    onChange={(e) =>
                      setPairDetils((prev) => ({
                        ...prev,
                        price: e.target.value,
                      }))
                    }
                    id="outlined-basic"
                    variant="outlined"
                    fullWidth
                  />
                </div>
              </div>

              <div className="view-inp p-10">
                <div className=" txt-white ">Min buy price</div>
                <div className="mt-10">
                  <TextField
                    value={pairDetils?.min_buy_price}
                    onChange={(e) =>
                      setPairDetils((prev) => ({
                        ...prev,
                        min_buy_price: e.target.value,
                      }))
                    }
                    id="outlined-basic"
                    variant="outlined"
                    fullWidth
                  />
                </div>
              </div>

              <div className="view-inp p-10">
                <div className=" txt-white ">Min sell price</div>
                <div className="mt-10">
                  <TextField
                    value={pairDetils?.min_sell_price}
                    onChange={(e) =>
                      setPairDetils((prev) => ({
                        ...prev,
                        min_sell_price: e.target.value,
                      }))
                    }
                    id="outlined-basic"
                    variant="outlined"
                    fullWidth
                  />
                </div>
              </div>

              <div className="view-inp p-10">
                <div className=" txt-white ">Min buy Quantity</div>
                <div className="mt-10">
                  <TextField
                    value={pairDetils?.min_buy_quantity}
                    onChange={(e) =>
                      setPairDetils((prev) => ({
                        ...prev,
                        min_buy_quantity: e.target.value,
                      }))
                    }
                    id="outlined-basic"
                    variant="outlined"
                    fullWidth
                  />
                </div>
              </div>

              <div className="view-inp p-10">
                <div className=" txt-white ">Min sell Quantity</div>
                <div className="mt-10">
                  <TextField
                    value={pairDetils?.min_sell_quantity}
                    onChange={(e) =>
                      setPairDetils((prev) => ({
                        ...prev,
                        min_sell_quantity: e.target.value,
                      }))
                    }
                    id="outlined-basic"
                    variant="outlined"
                    fullWidth
                  />
                </div>
              </div>

              <div className="view-inp p-10">
                <div className=" txt-white ">Buy trade commission</div>
                <div className="mt-10">
                  <TextField
                    value={pairDetils?.buy_trade_commission}
                    onChange={(e) =>
                      setPairDetils((prev) => ({
                        ...prev,
                        buy_trade_commission: e.target.value,
                      }))
                    }
                    id="outlined-basic"
                    variant="outlined"
                    fullWidth
                  />
                </div>
              </div>
            </Grid2>

            {/* Right Column */}
            <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}>
              <div className="view-inp p-10">
                <div className=" txt-white ">Type</div>
                <div className="mt-10">
                  <TextField
                    value={pairDetils?.type}
                    disabled={true}
                    id="outlined-basic"
                    variant="outlined"
                    fullWidth
                  />
                </div>
              </div>

              <div className="view-inp p-10">
                <div className=" txt-white ">Max buy price</div>
                <div className="mt-10">
                  <TextField
                    value={pairDetils?.max_buy_price}
                    onChange={(e) =>
                      setPairDetils((prev) => ({
                        ...prev,
                        max_buy_price: e.target.value,
                      }))
                    }
                    id="outlined-basic"
                    variant="outlined"
                    fullWidth
                  />
                </div>
              </div>

              <div className="view-inp p-10">
                <div className=" txt-white ">Max sell price</div>
                <div className="mt-10">
                  <TextField
                    value={pairDetils?.max_sell_price}
                    onChange={(e) =>
                      setPairDetils((prev) => ({
                        ...prev,
                        max_sell_price: e.target.value,
                      }))
                    }
                    id="outlined-basic"
                    variant="outlined"
                    fullWidth
                  />
                </div>
              </div>

              <div className="view-inp p-10">
                <div className=" txt-white ">Max buy Quantity</div>
                <div className="mt-10">
                  <TextField
                    value={pairDetils?.max_buy_quantity}
                    onChange={(e) =>
                      setPairDetils((prev) => ({
                        ...prev,
                        max_buy_quantity: e.target.value,
                      }))
                    }
                    id="outlined-basic"
                    variant="outlined"
                    fullWidth
                  />
                </div>
              </div>

              <div className="view-inp p-10">
                <div className=" txt-white ">Max sell Quantity</div>
                <div className="mt-10">
                  <TextField
                    value={pairDetils?.max_sell_quantity}
                    onChange={(e) =>
                      setPairDetils((prev) => ({
                        ...prev,
                        max_sell_quantity: e.target.value,
                      }))
                    }
                    id="outlined-basic"
                    variant="outlined"
                    fullWidth
                  />
                </div>
              </div>

              <div className="view-inp p-10">
                <div className=" txt-white ">Sell trade commission</div>
                <div className="mt-10">
                  <TextField
                    value={pairDetils?.sell_trade_commission}
                    onChange={(e) =>
                      setPairDetils((prev) => ({
                        ...prev,
                        sell_trade_commission: e.target.value,
                      }))
                    }
                    id="outlined-basic"
                    variant="outlined"
                    fullWidth
                  />
                </div>
              </div>
            </Grid2>
          </Grid2>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            disabled={isLoad}
            onClick={handleSave}
            variant="contained"
          >
            Save changes
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};

export default TradePair;
